import React, { ChangeEvent } from 'react';
import { Tab, TabGroup } from '@card/commonlib';
import { InputLabel } from '@increasecard/typed-components';
import {
  USFlatCorners,
  UruguayFlatCorners,
  ArgentinaFlatCorners,
  ColombiaFlatCorners,
  DominicanaFlatCorners
} from '@increasecard/icons';
import { useTranslation } from 'react-i18next';
import { Currency } from '@increasecard/increase-core/dist/types/Currency';

type CurrencyTabsProps = {
  currencies?: Currency[];
  onChange: (currency: Currency) => void;
  value: Currency;
};

interface FlagProps extends React.SVGProps<SVGSVGElement> {
  currency: Currency;
}

function Flag({ currency, ...rest }: FlagProps) {
  switch (currency) {
    case 'ARS':
      return <ArgentinaFlatCorners {...rest} />;
    case 'USD':
      return <USFlatCorners {...rest} />;
    case 'UYU':
      return <UruguayFlatCorners {...rest} />;
    case 'COP':
      return <ColombiaFlatCorners {...rest} />;
    case 'DOP':
      return <DominicanaFlatCorners {...rest} />;
    case 'PYG':
    case 'CLP':
    default:
      throw new Error(`Flag icon not implemented for ${currency}`);
  }
}

export const CurrencyTabs = ({
  currencies = ['UYU', 'USD'],
  value,
  onChange
}: CurrencyTabsProps) => {
  const { t } = useTranslation();
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    return onChange(event.currentTarget.value as Currency);
  };
  return (
    <TabGroup>
      <InputLabel style={{ padding: '0 16px', display: 'flex', alignItems: 'center' }} weight="500">
        {t('common:filters:currencyTabs:label')}
      </InputLabel>
      {currencies.map((currency) => (
        <Tab checked={value === currency} key={currency} onChange={handleChange} value={currency}>
          <Flag currency={currency} height="20" style={{ marginRight: '8px' }} width="34" />{' '}
          {currency}
        </Tab>
      ))}
    </TabGroup>
  );
};
